"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnTick_FailRoom_WhenAlliesDefeatedRoomScript = void 0;
const __1 = require("../../..");
const Registries_1 = require("../../state/Registries");
const mkDefaultMeta = () => ({});
let OnTick_FailRoom_WhenAlliesDefeatedRoomScript = class OnTick_FailRoom_WhenAlliesDefeatedRoomScript {
    run(sequence, container, state, args) {
        var _a;
        if (((_a = container.getRoom(state.id)) === null || _a === void 0 ? void 0 : _a.state) !== "Active") {
            return;
        }
        for (const ally of container.allies) {
            if (!container.isDeceased(ally)) {
                return;
            }
        }
        container.dispatch(sequence, 0, new __1.FailRoomActionArgs(state.id));
    }
};
OnTick_FailRoom_WhenAlliesDefeatedRoomScript = __decorate([
    Registries_1.RoomScripts.register("OnTick_FailRoom_WhenAlliesDefeated")
], OnTick_FailRoom_WhenAlliesDefeatedRoomScript);
exports.OnTick_FailRoom_WhenAlliesDefeatedRoomScript = OnTick_FailRoom_WhenAlliesDefeatedRoomScript;
